/* eslint-disable no-undef */
/* eslint-disable consistent-return */
/* eslint-disable no-use-before-define */

const siteKey = window.reCaptchaSiteKey;

function getFormGuid(formId) {
  try {
    const formElement = document.getElementById(formId);
    const formGuid = formElement
      .querySelector('[data-captchaguid]')
      .getAttribute('data-captchaguid');

    return formGuid;
  } catch {
    // Do nothing for now
  }
}

function onSubmit(e) {
  e.preventDefault();
  e.stopPropagation();

  const formGuid = getFormGuid(e.submitter.form.id);
  const element = document.getElementById(`${formGuid}-captchaToken`);

  if (!element || element.value !== '') {
    return;
  }

  grecaptcha.ready(() => {
    grecaptcha
      .execute(siteKey, { action: 'submit' })
      .then(token => {
        document.getElementById(`${formGuid}-captchaToken`).value = token;

        // trigger original click event
        if (e.submitter !== undefined) {
          window.kentico.updatableFormHelper.submitForm(e);
        }
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.error(error);
      });
  });
}

function initReCaptchaV3() {
  document.addEventListener('submit', onSubmit);
}

initReCaptchaV3();
